// A `setInterval` on the page itself is throttled to about once a minute once the window is
// minimised. A worker keeps ticking far more reliably, and everything downstream works off
// `Date.now()` plus a look-ahead window, so even a late tick still queues the clip in time.
const TICKER_WORKER_SOURCE = `
  var interval = setInterval(function () {
    self.postMessage(Date.now())
  }, 1000)

  self.onmessage = function (event) {
    if (event.data === "stop") {
      clearInterval(interval)
      self.close()
    }
  }
`

export function createTicker(onTick: () => void): () => void {
  const canUseWorker =
    typeof Worker !== "undefined" &&
    typeof Blob !== "undefined" &&
    typeof URL.createObjectURL === "function"

  if (canUseWorker) {
    try {
      const workerUrl = URL.createObjectURL(
        new Blob([TICKER_WORKER_SOURCE], { type: "application/javascript" }),
      )
      const worker = new Worker(workerUrl)

      worker.onmessage = () => onTick()

      return () => {
        worker.postMessage("stop")
        worker.terminate()
        URL.revokeObjectURL(workerUrl)
      }
    } catch {
      // A content security policy or a managed-browser policy can forbid blob: workers, and the
      // constructor throws right here. Falling through to the timer keeps the page running -
      // less reliable in the background, but a page that ticks slowly beats a blank screen.
    }
  }

  const interval = window.setInterval(onTick, 1000)
  return () => window.clearInterval(interval)
}
